<div class="dataset-card">
  <div class="dataset-card__head">
    <!-- <span class="dataset-card__label">Dataset {{ index + 1 }}</span> -->
    <span
      class="dataset-card__badge"
      [class.dataset-card__badge--primary]="dataset.isPrimary"
      [class.dataset-card__badge--join]="!dataset.isPrimary"
    >
      {{ dataset.isPrimary ? 'Primary dataset' : 'Join required' }}
    </span>
  </div>

  <p class="dataset-card__description">
    {{ dataset.isPrimary ? '' : 'Configure this table used to enrich or join another dataset.' }}
  </p>

  <div class="dataset-card__fields">
    <div class="dataset-card__field">
      <label class="dataset-card__field-label">Dataset name <span class="dataset-card__required">*</span></label>
      <input type="text" class="dataset-card__input" placeholder="Enter dataset name" [(ngModel)]="dataset.name" />
    </div>

    <div class="dataset-card__field">
      <label class="dataset-card__field-label">Select Datasource <span class="dataset-card__required">*</span></label>
      <mat-select
        class="dataset-card__select"
        panelClass="dataset-card__select-panel"
        placeholder="Select a datasource"
        [(ngModel)]="dataset.table_name"
        (selectionChange)="onDatasourceSelected($event.value)"
      >
        @for (option of datasourceOptions; track option) {
        <mat-option [value]="option.table_name" [disabled]="usedTableNames.includes(option.table_name)">
          {{ option.dataset_name }}
        </mat-option>
        }
      </mat-select>
    </div>
    <div class="dataset-card__field">
      <label class="dataset-card__field-label">Columns</label>
      <div class="dataset-card__group-btn">
        <button
          type="button"
          class="dataset-card__manage-btn"
          [disabled]="!dataset.table_name"
          (click)="onToggleManageColumns()"
        >
          <mat-icon aria-hidden="true">view_column</mat-icon>
          <span>{{ dataset.manageColumnsOpen ? 'Hide columns' : 'Manage columns' }}</span>
        </button>
        @if (canRemove) {
        <button
          type="button"
          class="dataset-card__schema-btn"
          [class.dataset-card__schema-btn--active]="dataset.relationshipsOpen"
          [disabled]="!dataset.table_name || !availableJoinTargets.length"
          (click)="onToggleRelationships()"
          aria-label="Establish relationships"
        >
          <mat-icon aria-hidden="true">schema</mat-icon>
        </button>
        } @if (canRemove) {
        <button type="button" class="dataset-card__delete-btn" (click)="remove.emit()" aria-label="Remove dataset">
          <mat-icon aria-hidden="true">delete_outline</mat-icon>
        </button>
        }
      </div>
    </div>
  </div>

  <div class="dataset-card__columns-bar" [hidden]="!dataset.manageColumnsOpen">
    <div class="dataset-card__columns-info">
      <span class="dataset-card__columns-title">
        {{ dataset.manageColumnsOpen ? 'Column management' : 'Columns' }}
      </span>
      @if (dataset.manageColumnsOpen) {
      <span class="dataset-card__columns-subtitle">
        Review the columns included in Dataset {{ index + 1 }} and define how each needs to be aggregated.
      </span>
      }
    </div>

    <div class="dataset-card__columns-actions">
      @if (dataset.manageColumnsOpen && dataset.columns.length) {
      <label class="dataset-card__use-all">
        <input type="checkbox" [checked]="allColumnsSelected" (change)="onUseAllColumns()" />
        <span>Use all columns</span>
      </label>
      } @if (dataset.manageColumnsOpen && dataset.columns.length) {
      <span class="dataset-card__columns-count">
        {{ dataset.columns.length }} COLUMN{{ dataset.columns.length === 1 ? '' : 'S' }}
      </span>
      }
    </div>
  </div>

  @if (dataset.manageColumnsOpen) {
  <div class="dataset-card__column-table">
    <app-dataset-column-table [columns]="dataset.columns" [loading]="dataset.columnsLoading"></app-dataset-column-table>
  </div>
  } @if (canRemove && dataset.relationshipsOpen) {
  <div class="dataset-card__relationships">
    <div class="dataset-card__relationships-head">
      <div class="dataset-card__columns-info">
        <span class="dataset-card__columns-title">Established relationships</span>
        <span class="dataset-card__columns-subtitle">Review and extend the current join setup between datasets.</span>
      </div>
      <span
        class="dataset-card__badge"
        [class.dataset-card__badge--primary]="relationshipsConfigured"
        [class.dataset-card__badge--join]="!relationshipsConfigured"
      >
        {{ relationshipsConfigured ? 'Configured' : 'Join required' }}
      </span>
    </div>
    @for (join of dataset.joins; track trackByJoinId(j, join); let j = $index) {
    <div class="dataset-card__join">
      <div class="dataset-card__join-head">
        <span class="dataset-card__join-title">Join {{ j + 1 }}</span>
        <span
          class="dataset-card__badge"
          [class.dataset-card__badge--primary]="isJoinConfigured(join)"
          [class.dataset-card__badge--join]="!isJoinConfigured(join)"
        >
          {{ isJoinConfigured(join) ? 'Configured' : 'Join required' }}
        </span>
        @if (dataset.joins.length > 1) {
        <button type="button" class="dataset-card__join-remove" (click)="onRemoveJoin(join)" aria-label="Remove join">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
        }
      </div>
      <div class="dataset-card__join-fields">
        <div class="dataset-card__field">
          <label class="dataset-card__field-label">Dataset</label>
          <mat-select
            class="dataset-card__select"
            placeholder="Select a dataset"
            [(ngModel)]="join.targetDatasetId"
            (selectionChange)="onJoinTargetChange(join)"
          >
            @for (target of availableJoinTargets; track target) {
            <mat-option [value]="target.id">
              {{ target.table_name }}
            </mat-option>
            }
          </mat-select>
        </div>
        <div class="dataset-card__field">
          <label class="dataset-card__field-label">
            <!-- <mat-icon aria-hidden="true">join_inner</mat-icon> -->
            Join type
          </label>
          <mat-select
            class="dataset-card__select"
            placeholder="Select join type"
            [(ngModel)]="join.joinType"
            [disabled]="!join.targetDatasetId"
          >
            @for (option of getJoinTypeOptions(join); track option) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </div>
      </div>
      <div class="dataset-card__mapping">
        <div class="dataset-card__mapping-head">
          <span>Column mapping</span>
        </div>
        <div class="dataset-card__mapping-guide">
          {{ getDatasetById(join.targetDatasetId)?.table_name }} -&gt; {{ dataset.table_name }}
        </div>
        @for (mapping of join.columnMappings; track trackByMappingId($index, mapping)) {
        <div class="dataset-card__mapping-row">
          <div class="dataset-card__field">
            <label class="dataset-card__field-label">Left column</label>
            <mat-select
              class="dataset-card__select"
              panelClass="dataset-card__select-panel"
              placeholder="Select column"
              [(ngModel)]="mapping.leftColumn"
            >
              <div class="dataset-card__select-search" (click)="$event.stopPropagation()">
                <input
                  type="text"
                  placeholder="Search column"
                  [(ngModel)]="mapping.leftColumnSearch"
                  (keydown)="$event.stopPropagation()"
                />
              </div>
              @for (column of filterColumns(getDatasetById(join.targetDatasetId)?.columns, mapping.leftColumnSearch);
              track column) {
              <mat-option [value]="column.key">
                {{ column.name }}
              </mat-option>
              }
            </mat-select>
          </div>
          <div class="dataset-card__field">
            <label class="dataset-card__field-label">Right column</label>
            <mat-select
              class="dataset-card__select"
              panelClass="dataset-card__select-panel"
              placeholder="Select column"
              [(ngModel)]="mapping.rightColumn"
            >
              <div class="dataset-card__select-search" (click)="$event.stopPropagation()">
                <input
                  type="text"
                  placeholder="Search column"
                  [(ngModel)]="mapping.rightColumnSearch"
                  (keydown)="$event.stopPropagation()"
                />
              </div>
              @for (column of filterColumns(dataset.columns, mapping.rightColumnSearch); track column) {
              <mat-option [value]="column.key">
                {{ column.name }}
              </mat-option>
              }
            </mat-select>
          </div>
          @if (join.columnMappings.length > 1) {
          <button
            type="button"
            class="dataset-card__mapping-remove"
            (click)="onRemoveColumnMapping(join, mapping)"
            aria-label="Remove column mapping"
          >
            <mat-icon aria-hidden="true">close</mat-icon>
          </button>
          }
        </div>
        @if (getMappingError(join, mapping); as mappingError) {
        <div class="dataset-card__mapping-error">
          {{ mappingError }}
        </div>
        } }
        <button type="button" class="dataset-card__add-mapping" (click)="onAddColumnMapping(join)">
          <mat-icon aria-hidden="true">add</mat-icon>
          <span>Add column mapping</span>
        </button>
      </div>
    </div>
    }
    <button
      type="button"
      class="dataset-card__add-join"
      (click)="onAddJoin()"
      [disabled]="!availableJoinTargets.length"
    >
      <mat-icon aria-hidden="true">add</mat-icon>
      <span>Add join</span>
    </button>
  </div>
  }
</div>
